import { render, staticRenderFns } from "./NewEmailContact.vue?vue&type=template&id=538b2161&scoped=true&"
import script from "./NewEmailContact.vue?vue&type=script&lang=js&"
export * from "./NewEmailContact.vue?vue&type=script&lang=js&"
import style0 from "./NewEmailContact.vue?vue&type=style&index=0&id=538b2161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b2161",
  null
  
)

export default component.exports